import React from 'react'
import PropTypes from 'prop-types'

const renderLogo = ({
  url,
  name,
}) => {
  let logo = <span />
  if (url) {
    logo = <img src={url} alt='logo brand' />
  } else if (name) {
    logo = <span className='logo-text h2'>{name}</span>
  } else {
    logo = <span className='logo-text h2'>My Brand</span>
  }
  return logo
}

const Logo = ({
  logoURL,
  canonicalName,
}) => (
  <a href={window.location.origin} className='logo'>
    {renderLogo({ url: logoURL, name: canonicalName })}
  </a>
)

Logo.propTypes = {
  logoURL: PropTypes.string,
  canonicalName: PropTypes.string,
}

Logo.defaultProps = {
  logoURL: '/',
  canonicalName: '',
}

export default Logo
